import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

const globalStyles = createGlobalStyle`
  ${reset}

  ;
  * {
    box-sizing: border-box;
    line-height: 1.2;
    letter-spacing: -0.03em;
    word-break: keep-all;
    font-family: 'Apple SD Gothic Neo', sans-serif;
  }

  html,
  body,
  div,
  dl,
  dt,
  dd,
  ul,
  ol,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  pre,
  code,
  form,
  fieldset,
  legend,
  input,
  textarea,
  p,
  blockquote,
  th,
  td,
  img {
    margin: 0;
    padding: 0;
  }

  html {
    width: 100%;
  }

  body#popup {
    min-width: 0;
  }

  li {
    list-style: none;
  }

  img,
  fieldset {
    border: none;
    vertical-align: middle;
  }

  table {
    width: 100%;
    border: 0;
    border-spacing: 0;
    border-collapse: collapse;
  }

  caption {
    display: none;
  }

  th,
  td {
    border: 0;
    vertical-align: middle;
  }

  div {
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
  }

  button {
    overflow: visible;
    padding: 0;
    margin: 0;
    border: 0;
    cursor: pointer;
    background: transparent;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
  }

  hr.layout {
    display: none;
  }

  select {
    -webkit-appearance: none;
    background:url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    background-size:20px 20px;
  }

  a {
    text-decoration: none;
    color: #000;
  }

  a:hover {
    text-decoration: none;
  }

  a:active {
    text-decoration: none;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px #fff inset;
    -webkit-text-fill-color: #000;
  }

  input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
  
  input[type='checkbox']{
    display:none;
    
    + label {
      cursor:pointer;
      display:inline-block;
      width:20px;
      height:20px;
      background:url('https://ust-erp.s3.ap-northeast-2.amazonaws.com/icon/check_box_off.webp') 50% 50%no-repeat;
      background-size:20px 20px;
    }
  }

  input[type='checkbox']:checked + label {
    background:url('https://ust-erp.s3.ap-northeast-2.amazonaws.com/icon/check_box_on.webp') 50% 50%no-repeat;
    background-size:20px 20px;

  }

  input[type='radio'] {
    appearance: none;
    display: block;
    width: 20px;
    height: 20px;
    background: url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/radio_off.svg') 50% 50% no-repeat;
  }

  input[type='radio']:checked {
    background-image: url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/radio_on.svg');
  }
  
  .content-inner {
    .title {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      
      .title-head {
        display: flex;
        align-items: center;
        gap: 0 10px;
        
        i {
          display: block;
          width: 4px;
          height: 32px;
          border-radius: 0 2px 2px 0;
          background: #1e1e1e;
        }
        
        h4 {
          font-weight: 500;
          font-size: 16px;
          color: #000000;
        }
      }
    }
    
    .search-area {
      position: relative;
      margin-top: 35px;
      padding: 15px 20px;
      border-top: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      align-items: center;
      gap: 0 15px;
      width: 100%;
      
      &.space {
        justify-content: space-between;
        
        .search-menu {
          display:flex;
          align-items: center;
          gap:0 15px;
        }
      }
      
      .date-box {
        position:relative;
        width:100%;
        display: flex;
        align-items: center;
        gap: 0 15px;

        input {
          width: 160px;
          height: 40px;
          line-height: 40px;
          padding: 0 16px;
          font-weight: 400;
          font-size: 16px;
          color: #777777;
          background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/date_ic.svg') top 50% right 10px no-repeat;
          border: 1px solid rgba(0, 0, 0, 0.12);
          border-radius: 5px;
          outline: none;
        }

        i {
          display: block;
          width: 12px;
          height: 1px;
          background: rgba(0, 0, 0, 0.12);
        }

       .react-datepicker-popper {
          width: 226px;
          z-index: 99;
        }
        
        .search-btn {
          width: 120px;
          height: 40px;
          line-height: 40px;
          border-radius: 5px;
          background: #a4a4a4;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;

          &:hover {
            background-color: #7e7e7e;
          }
        }
      }
    }
    
    .util-box {
      position: relative;
      padding: 15px 20px;
      border-top: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0 15px;
      width: 100%;
      
      .util-menu {
        display:flex;
        align-items:center;
        gap:0 20px;
        
        select {
          width: 160px;
          height: 40px;
          line-height: 40px;
          padding: 0 32px 0 16px;
          font-weight: 400;
          font-size: 16px;
          color: #777777;
          background: #f8f8f8 url('https://ust-erp.s3.ap-northeast-2.amazonaws.com/icon/chevron-down.webp') no-repeat top 50% right 10px;
          border: 1px solid rgba(0, 0, 0, 0.12);
          border-radius: 5px;
          outline: none;
          
          &.message {
            width:300px;
          }
        }
        
        input {
          width: 160px;
          height: 40px;
          line-height: 40px;
          padding: 0 16px;
          font-weight: 400;
          font-size: 16px;
          color: #777777;
          background: #f8f8f8;
          border: 1px solid rgba(0, 0, 0, 0.12);
          border-radius: 5px;
          outline: none;
        }
      }
      
      .search-btn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        background: #a4a4a4;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;

        &:hover {
          background-color: #7e7e7e;
        }
      }
    }
    
    .content {
      margin-top: 35px;
      position: relative;
      height: 648px;
      overflow-y:auto;

      &::-webkit-scrollbar {
        display: none;
      }
      
      &.noArea {
        height:755px;
      }
    }
    
    .pagination {
      margin-top:30px;
      display:flex;
      align-items: center;
      justify-content: center;
      gap:0 15px;
      
      ul {
        display:flex;
        align-items: center;
        justify-content: center;
        gap:0 15px;
        
        li {
          span {
            cursor:pointer;
            font-weight:400;
            font-size:14px;
            color:#111111;

            &.selected span {
              font-weight:700;
            }
          }
        }
      }
    }
  }
  
  .modal-box {
    padding: 40px;
    width:900px;
    background: #ffffff;
    border-radius: 20px;
    box-sizing: content-box;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);

  
  
    .inner {
      overflow-y: auto;
      
      .form-in {
        
        margin-top:30px;
        
        select {
          width:100%;
          height:40px;
          line-height:40px;
          padding:0 16px;
          border-radius:4px;
          border:1px solid #dddddd;
          background:url('https://ust-kr.s3.ap-northeast-2.amazonaws.com/assets/layout/drop_arrow.svg') right 16px top 50% no-repeat;
          outline:none;
          font-weight:400;
          font-size:14px;
        }

        textarea {
          width:100%;
          min-height:140px;
          padding:10px;
          font-weight:400;
          font-size:16px;
          color:#111111;
          border-radius:4px;
        }
      }
      
      form {
        position:relative;
        width:100%;
        
        select {
          width:100%;
          height:40px;
          line-height:40px;
          padding:0 16px;
          border-radius:4px;
          border:1px solid #dddddd;
          background:url('https://ust-kr.s3.ap-northeast-2.amazonaws.com/assets/layout/drop_arrow.svg') right 16px top 50% no-repeat;
          outline:none;
          font-weight:400;
          font-size:14px;
        }
        
        textarea {
          width:100%;
          min-height:140px;
          padding:10px;
          font-weight:400;
          font-size:16px;
          color:#111111;
          border-radius:4px;
        }
      }
      
      &::-webkit-scrollbar {
        display: none;
      }
      
      .modal-head {
        display: flex;
        align-items: center;
        gap: 0 10px;

        & i {
          display: block;
          width: 4px;
          height: 32px;
          border-radius: 0 2px 2px 0;
          background: #1e1e1e;
        }

        & h4 {
          font-weight: 700;
          font-size: 18px;
          color: #000000;
        }
      }
      
      .modal-content {
        margin-top:30px;
        position:relative;

        .img-box {
          position:relative;
          text-align:center;
          
          img {
            width:auto;
            height:auto;
            max-height:75vh;
            object-fit: contain;
          }
        }
        
        table {
          position:relative;
          
          th {
            padding:10px 0;
            text-align:center;
            vertical-align: middle;
            font-weight:600;
            font-size:16px;
            color:#111111;
            background:#dddddd;
          }
          
          td {
            padding:10px;
            text-align:center;
            
            input, select {
              width:100%;
              height:40px;
              line-height:40px;
              padding:0 16px;
              border-radius:4px;
              border:1px solid #717171;
              outline:none;
              font-weight:400;
              font-size:14px;
            }
            
            select {
              background:url('https://ust-kr.s3.ap-northeast-2.amazonaws.com/assets/layout/drop_arrow.svg') right 16px top 50% no-repeat;
            }
          }
        }
      }
    }

    @media only screen and (max-width: 1024px) {
      width:85vw;
      padding:20px;
    }
  }
  
  .edit-btn {
    margin-top:35px;
    display:flex;
    align-items: center;
    justify-content: center;
    gap:0 20px;
    
    button {
      display:block;
      flex:1;
      height:40px;
      line-height:40px;
      border-radius:8px;
      font-weight:400;
      font-size:16px;
      color:#000000;
      border:1px solid #000000;
      
      &.submit {
        border-color:#0072B9;
        background:#0072B9;
        color:#ffffff;
      }
      &.delete {
        border-color:#e83030;
        background:#e83030;
        color:#ffffff;
      }
      
      &.cancel {
        border-color:#a4a4a4;
        background:#a4a4a4;
        color:#ffffff;
      }
    }
  }
  
  
`;

export default globalStyles;
